import styled from "styled-components";
import { sizes } from "../../01_config/Sizes";

const ButtonTop = styled.button`
  position: fixed;
  right: ${sizes.margins_desk};
  bottom: 20px;
  z-index: 300;
  padding: 10px 16px;
  border-radius: 999px;
  border: none;
  background: black;
  color: white;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  opacity: 0.7;

  &:hover {
    opacity: 0.9;
  };
`

export { ButtonTop }